
    <div style="padding: 2em">
    <h1 mat-dialog-title style="text-align: center;
    font-size: 2em;
    color: #4f4f4f;">HVAC Grading Data Required</h1>
    <div>
      <p style="font-size: 1.5em;
      color: #424242;">This is a job in which HVAC Grading data is needed. Please ensure the Lineset Length, and Liquid Diameter is filled in for each system (Hvac Grading Tab).  </p>
    </div>
    <div style="margin: auto;
    padding-left: 25%;
    padding-right: 25%;
    padding-top: 2em;">
      <button mat-button [mat-dialog-close]="1"  style="margin-right: 2em; height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Close Anyway</button>
      <button mat-button [mat-dialog-close]="2"  style="    height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Back To Form</button>
    </div>
    </div>
  